<template>
  <CancelSaleModal />
  <div class="modal fade view-sale-modal" id="ViewSaleModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Detalhes da venda</h1>
                  <button type="button" class="btn-close view-sale-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <div class="modal-body ps-30 pe-30">
                
                <div class="row mb-3">
                  <div class="col-md-6">
                    <p><strong>Data:</strong> {{ getCurrentViewSale.sale_date ? formatDate(getCurrentViewSale.sale_date) : '-' }}</p>
                    <p><strong>Vendedor:</strong> {{ getCurrentViewSale.user ? getCurrentViewSale.user.name : '-' }}</p>
                    <p><strong>Cliente:</strong> {{ getCurrentViewSale.client ? getCurrentViewSale.client.phone + ' - ' +getCurrentViewSale.client.name : 'Não informado' }}</p>
                  </div>
                  <div class="col-md-6">
                    <p><strong>Valor Total:</strong> R$ {{ getCurrentViewSale.total ? parseFloat(getCurrentViewSale.total).toFixed(2).replace('.', ',') : '0,00' }}</p>
                    <p><strong>Status:</strong> <span :class="getStatusBadge(getCurrentViewSale.active)">{{ formatStatus(getCurrentViewSale.active) }}</span></p>
                  </div>
                </div>

                <hr>

                <h6 class="mt-4 mb-3"><strong>Itens da venda:</strong></h6>
                <div class="table-responsive">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th>Produto</th>
                        <th>Preço Unitário</th>
                        <th>Quantidade</th>
                        <th>Subtotal</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in getCurrentViewSale.entries" :key="item.id">
                        <td class="view-sale-product-cell">
                          <button type="button" class="view-sale-product-button" @click="toggleProductPopover(item, $event)">
                            <span class="view-sale-product-name">{{ item.product_name || '-' }}</span>
                            <small class="view-sale-product-sku">{{ item.sku || '-' }}</small>
                          </button>
                        </td>
                        <td>R$ {{ parseFloat(item.price).toFixed(2).replace('.', ',') }}</td>
                        <td>{{ item.quantity || 1 }}</td>
                        <td>R$ {{ parseFloat(item.total || 0).toFixed(2).replace('.', ',') }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <hr>

                <div v-if="getCurrentViewSale.notes">
                  <h6 class="mt-3 mb-2"><strong>Observações:</strong></h6>
                  <p class="bg-light p-3 rounded">{{ getCurrentViewSale.notes }}</p>
                </div>

              </div>
              
              <div class="modal-footer">
                  <button type="button" class="btn btn-secondary view-sale-modal" data-bs-dismiss="modal">Fechar</button>
                  <button v-if="getCurrentViewSale.active" type="button" class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#CancelSaleModal">Cancelar venda</button>
              </div>
          </div>
      </div>
  </div>
  <div
    v-if="activeProductPopover"
    class="view-sale-product-popover"
    :class="{ 'view-sale-product-popover--above': activeProductPopover.placement === 'above' }"
    :style="{ left: `${activeProductPopover.left}px`, top: `${activeProductPopover.top}px` }"
  >
    <strong>{{ activeProductPopover.name }}</strong>
    <span>{{ activeProductPopover.sku }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CancelSaleModal from './CancelSaleModal.vue';

export default {
  name: "ViewSaleModal",
  components: {
    CancelSaleModal
  },
  data() {
    return {
      activeProductPopover: null
    };
  },
  computed: {
    ...mapGetters([
      "getCurrentViewSale"
    ])
  },
  methods: {
    toggleProductPopover(item, event) {
      const popoverId = item.id || `${item.product_name}-${item.sku}`;

      if (this.activeProductPopover && this.activeProductPopover.id === popoverId) {
        this.activeProductPopover = null;
        return;
      }

      const rect = event.currentTarget.getBoundingClientRect();
      const popoverWidth = Math.min(320, window.innerWidth - 24);
      const left = Math.min(Math.max(rect.left, 12), window.innerWidth - popoverWidth - 12);
      const shouldShowAbove = rect.bottom + 88 > window.innerHeight;

      this.activeProductPopover = {
        id: popoverId,
        left,
        top: shouldShowAbove ? rect.top - 8 : rect.bottom + 8,
        placement: shouldShowAbove ? 'above' : 'below',
        name: item.product_name || '-',
        sku: item.sku || '-'
      };
    },
    clearProductPopover() {
      this.activeProductPopover = null;
    },
    handleProductPopoverOutsideClick(event) {
      if (!this.activeProductPopover) return;

      const clickedInsidePopover = event.target.closest('.view-sale-product-popover');
      const clickedProductButton = event.target.closest('.view-sale-product-button');

      if (!clickedInsidePopover && !clickedProductButton) {
        this.activeProductPopover = null;
      }
    },
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      return d.toLocaleDateString('pt-BR', { 
        day: '2-digit', 
        month: '2-digit', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    formatStatus(status) {
      const statusMap = {
        true: 'Concluída',
        false: 'Cancelada'
      };
      return statusMap[status] || status;
    },
    getStatusBadge(status) {
      const badgeMap = {
        true: 'badge bg-success radius-7',
        false: 'badge bg-danger radius-7'
      };
      return badgeMap[status] || 'badge bg-secondary radius-7';
    }
  },
  mounted() {
    document.addEventListener('click', this.handleProductPopoverOutsideClick);

    const modalElement = document.getElementById('ViewSaleModal');
    if (modalElement) {
      modalElement.addEventListener('hide.bs.modal', this.clearProductPopover);
    }
  },
  unmounted() {
    document.removeEventListener('click', this.handleProductPopoverOutsideClick);

    const modalElement = document.getElementById('ViewSaleModal');
    if (modalElement) {
      modalElement.removeEventListener('hide.bs.modal', this.clearProductPopover);
    }
  }
};
</script>

<style scoped>
.view-sale-modal .table {
  min-width: 560px;
}

.view-sale-product-cell {
  min-width: 190px;
  white-space: nowrap;
  width: 190px;
}

.view-sale-product-button {
  background: transparent;
  border: 0;
  color: inherit;
  display: block;
  max-width: 160px;
  padding: 0;
  text-align: left;
}

.view-sale-product-name,
.view-sale-product-sku {
  display: block;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.view-sale-product-name {
  color: #2f3152;
}

.view-sale-product-sku {
  color: #6b7280;
  font-size: 12px;
  margin-top: 3px;
}

.view-sale-product-popover {
  background: #111827;
  border-radius: 7px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.22);
  color: #ffffff;
  max-height: 160px;
  max-width: min(320px, 72vw);
  overflow-y: auto;
  padding: 10px 12px;
  position: fixed;
  transform: none;
  white-space: normal;
  width: min(320px, calc(100vw - 24px));
  z-index: 2200;
}

.view-sale-product-popover::after {
  border-bottom: 7px solid #111827;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  content: "";
  left: 18px;
  position: absolute;
  top: -7px;
}

.view-sale-product-popover--above {
  transform: translateY(-100%);
}

.view-sale-product-popover--above::after {
  border-bottom: 0;
  border-top: 7px solid #111827;
  bottom: -7px;
  top: auto;
}

.view-sale-product-popover strong,
.view-sale-product-popover span {
  display: block;
}

.view-sale-product-popover strong {
  font-size: 13px;
  line-height: 1.35;
}

.view-sale-product-popover span {
  color: #cbd5e1;
  font-size: 12px;
  margin-top: 4px;
  word-break: break-all;
}

@media (max-width: 575.98px) {
  .view-sale-modal .modal-body {
    padding-left: 18px !important;
    padding-right: 18px !important;
  }

  .view-sale-modal .table {
    min-width: 520px;
  }

  .view-sale-product-cell {
    min-width: 170px;
    width: 170px;
  }

  .view-sale-product-button,
  .view-sale-product-name,
  .view-sale-product-sku {
    max-width: 145px;
  }
}
</style>
